var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Chart',{ref:"ref__chart",staticClass:"w-full",attrs:{"options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }